import { render, staticRenderFns } from "./AccountMyShippingCartItem.vue?vue&type=template&id=6fb5a708&"
import script from "./AccountMyShippingCartItem.vue?vue&type=script&lang=ts&"
export * from "./AccountMyShippingCartItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports